"use strict";

exports.__esModule = true;
exports.StyledHeading = exports.Heading = void 0;

var React = _interopRequireWildcard(require("react"));

var _styled = require("@manifest-ui/styled");

var _jsxFileName = "/home/runner/work/manifest-ui/manifest-ui/packages/typography/src/Heading.tsx";

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const StyledHeading = (0, _styled.styled)('span', {
  label: 'Heading',
  shouldForwardProp: prop => (0, _styled.shouldForwardProp)(prop) && prop !== 'isBold',
  themeKey: 'heading'
})(({
  isBold,
  variant
}) => ({
  fontFamily: 'body',
  fontWeight: 'normal',
  letterSpacing: 'tight',
  margin: 0,
  ...(isBold && {
    fontWeight: 'bold'
  }),
  ...(variant === 'h1' && {
    fontSize: 'xxxx-large',
    lineHeight: 'xx-large'
  }),
  ...(variant === 'h2' && {
    fontSize: 'xxx-large',
    lineHeight: 'xx-large'
  }),
  ...(variant === 'h3' && {
    fontSize: 'xx-large',
    lineHeight: 'x-large'
  }),
  ...(variant === 'h4' && {
    fontSize: 'x-large',
    lineHeight: 'x-large'
  }),
  ...(variant === 'h5' && {
    fontSize: 'large',
    lineHeight: 'large'
  }),
  ...(variant === 'h6' && {
    fontSize: 'medium',
    lineHeight: 'large'
  })
}));
exports.StyledHeading = StyledHeading;
const Heading = React.forwardRef((props, ref) => {
  const {
    variant = 'h1',
    ...other
  } = props;
  return React.createElement(StyledHeading, _extends({
    as: variant,
    ref: ref,
    variant: variant
  }, other, {
    __self: void 0,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 68,
      columnNumber: 12
    }
  }));
});
exports.Heading = Heading;
Heading.displayName = 'Heading';